import React, { useEffect, useState } from "react";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { getFormattedDate } from "modules/utilities/utility";
import InvoiceCanvas from "./InvoiceCanvas";
import { Placeholder } from "react-bootstrap";

function InvoiceHistoryTable({ invoiceHisData, tab, invHisLoading }) {
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [page, newPage] = useState(1);
  const [sortData, setSortedData] = useState([]);



  useEffect(() => {
    setSortedData(invoiceHisData);
  }, [invoiceHisData]);

  useEffect(() => {
    const numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);
    const arrayOfArrays = sortData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[page - 1]);
  }, [sortData, page]);

  return (
    <div>
      <div>
        <div className="fs-1 p-2 mt-n3 text-black">
          {tab === "invoice" ? "Recent Invoices" : "Recent Credit Notes"}
        </div>
        <div
          className="border border-rounded scrollable-container"
          style={{ maxHeight: "60vh", minHeight: "20vh", overflowY: "scroll" }}
        >
          <table className="table table-responsive table-striped table-bordered rounded table-hover">
            <thead
              style={{
                background: "rgb(249, 250, 253)",
                position: "sticky",
                top: 0,
              }}
              className="rounded-top text-black p-3 align-top"
            >
              <tr className="d-flex fw-bold align-top top-0">
                <th className="flex-1 fs-1 p-3 align-top text-center">Date</th>
                <th className="flex-1 fs-1 p-3 align-top text-center">Total</th>
                <th className="flex-1 fs-1 p-3 align-top text-center">
                  Processed Order
                </th>
                <th className="flex-1 fs-1 p-3 align-top text-center">
                  Valid Orders
                </th>
                <th className="flex-1 fs-1 p-3 align-top text-center">
                  Error Orders
                </th>
              </tr>
            </thead>
            <tbody>
              {invHisLoading ? (
                <>
                  <tr>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                  </tr>
                </>
              ) : (
                Array.isArray(filterData) &&
                filterData?.map((item, index) => (
                  <tr key={index} className="d-flex">
                    <td className="flex-1 p-3 text-primary text-center">
                      <InvoiceCanvas
                        iconTab={getFormattedDate(item?.createdAt)}
                        userName={getFormattedDate(item?.createdAt)}
                        record={item}
                        tab={tab}
                      />
                    </td>
                    <td className="flex-1 p-3 text-black text-center">
                      {item?.totalOrders}
                    </td>
                    <td className="flex-1 p-3 text-black text-center">
                      {item?.processed}
                    </td>
                    <td className="flex-1 p-3 text-black text-center">
                      {item?.valid?.length}
                    </td>
                    <td className="flex-1 text-black text-center">
                      {item?.invalid?.length}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <PaginationDiv
          paginationData={{ pageCount: pageCount || 1, page: page }}
          newPage={newPage}
          activePage={page}
        />
      </div>
    </div>
  );
}

export default InvoiceHistoryTable;
